import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { notify, convertISOToAwardDate } from "../../functions/function";

import { connect } from "react-redux";

import axios from "axios";
import { fetchUserPlacements } from "../../reducers/UserPlacementsReducer";
import store from "../../store";
import CustomDatePicker from "../../components/CustomDatePicker";
import { iStaffBaseURL } from "src/constants/Urls";

import SmallLoadingSpinner from "../../components/SmallLoadingSpinner";
import { dispatchCreateClient } from "./helperFunctions";

const CreateClientModal = ({
  show,
  handleClose,
  event,
  userToken,
  clients,
  dispatch,
}) => {
  /* Event refers to the user movement (i.e. clicking and dragging) */
  /* using same names as model fields in Django */
  const [formData, setFormData] = useState({
    istaff_id: "",
    company_name: null,
    company_secondname: "client",
    company_address: "",
    company_contact: "",
    award_name: "",
    registration_number: "",
    award_date: new Date(),
    client_logo_uri: "",
    email: "",
    password: "",
    confirmpassword: "",
  });

  const [modalError, setModalError] = useState({
    foundErrors: false,
    errorMessage: "Please Try Again",
    istaff_id: "",
    company_name: "",
    company_secondname: "",
    company_address: "",
    company_contact: "",
    award_name: "",
    registration_number: "",
    award_date: "",
    client_logo_uri: "",
    email: "",
    password1: "",
    password2: "",
  });

  const [state, setState] = useState({
    loading: false,
  });

  useEffect(() => {
    setModalError((modalError) => {
      return { ...modalError, foundErrors: false };
    });
  }, [event]);

  const handleOnChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleAwardDateChange = (e) => {
    setFormData({ ...formData, award_date: e });
  };

  const handleSubmit = (userToken, clients, dispatch) => {
    setState({ loading: true });

    modalError.award_name = "";
    modalError.company_address = "";
    modalError.company_contact = "";
    modalError.company_name = "";
    modalError.email = "";
    modalError.first_name = "";
    modalError.istaff_id = "";
    modalError.password1 = "";
    modalError.password2 = "";
    modalError.registration_number = "";

    if (formData) {
      axios
        .post(
          iStaffBaseURL + `/client/registration/`,
          {
            first_name: formData.company_name,
            last_name: "Client",
            email: formData.email,
            password1: formData.password,
            password2: formData.confirmpassword,
            istaff_id: formData.istaff_id ? formData.istaff_id : "",
            company_name: formData.company_name,
            company_address: formData.company_address
              ? formData.company_address
              : "",
            company_contact: formData.company_address
              ? formData.company_address
              : "",
            award_name: formData.award_name ? formData.award_name : "",
            registration_number: formData.registration_number,
            award_date: convertISOToAwardDate(formData.award_date),
            client_logo_uri: formData.client_logo_uri
              ? formData.client_logo_uri
              : "",
          },
          {
            headers: { Authorization: `Token ${userToken}` },
          }
        )
        .then((response) => {
          var clientObjectToAdd = {
            istaff_id: formData.istaff_id ? formData.istaff_id : "",
            company_name: formData.company_name,
            company_address: formData.company_address
              ? formData.company_address
              : "",
            company_contact: formData.company_address
              ? formData.company_address
              : "",
            award_name: formData.award_name ? formData.award_name : "",
            registration_number: formData.registration_number,
            award_date: convertISOToAwardDate(formData.award_date),
            client_logo_uri: formData.client_logo_uri
              ? formData.client_logo_uri
              : "",
          };

          dispatchCreateClient(dispatch, clientObjectToAdd, clients);
          store.dispatch(fetchUserPlacements);
          setState({ loading: false });
          notify(
            "Success",
            "Successfully created new client. Make sure they verify their email so they can log in!",
            "success"
          );
          setModalError({ ...modalError, foundErrors: false });
          handleClose();
        })
        .catch((error) => {
          const errorObj = error.response.data;

          Object.keys(errorObj).forEach(function (key) {
            if (key === "award_name") {
              const modalErrorMessage = errorObj[key][0];
              modalError.award_name = modalErrorMessage;
            }
            if (key === "company_address") {
              const modalErrorMessage = errorObj[key][0];
              modalError.company_address = modalErrorMessage;
            }
            if (key === "company_contact") {
              const modalErrorMessage = errorObj[key][0];
              modalError.company_contact = modalErrorMessage;
            }
            if (key === "company_name") {
              const modalErrorMessage = errorObj[key][0];
              modalError.company_name = modalErrorMessage;
            }

            if (key === "email") {
              const modalErrorMessage = errorObj[key][0];
              modalError.email = modalErrorMessage;
            }

            if (key === "first_name") {
              const modalErrorMessage = errorObj[key][0];
              modalError.first_name = modalErrorMessage;
            }

            if (key === "istaff_id") {
              const modalErrorMessage = errorObj[key][0];
              modalError.istaff_id = modalErrorMessage;
            }
            if (key === "password1") {
              const modalErrorMessage = errorObj[key][0];
              modalError.password1 = modalErrorMessage;
            }
            if (key === "password2") {
              const modalErrorMessage = errorObj[key][0];
              modalError.password2 = modalErrorMessage;
            }

            if (key === "registration_number") {
              const modalErrorMessage = errorObj[key][0];
              modalError.registration_number = modalErrorMessage;
            }
          });

          notify("Failed ", "Error occured. Please try again", "danger");

          setState({ loading: false });
          setModalError({ ...modalError, foundErrors: true });
        });
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size={"l"}>
      <Modal.Header closeButton>
        <Modal.Title>Create New Client </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="text-left">
          {modalError.foundErrors ? (
            <Form.Label style={{ color: "red" }}>
              Error occured. Please Try Again
            </Form.Label>
          ) : (
            <>
              <Form.Label className="text-danger">
                NB: All fields except the client logo URI is required.{"\n"}
              </Form.Label>
              <Form.Label className="text-danger">
                NB: The client must verify their email by clicking the link in
                the verification email we send.
              </Form.Label>
            </>
          )}

          <Form.Group>
            <Form.Label column sm="50">
              iStaff I.D:
            </Form.Label>

            <Form.Control
              placeholder="iStaff Id"
              onChange={handleOnChange}
              name={"istaff_id"}
            />

            {modalError.istaff_id && modalError.foundErrors ? (
              <p style={{ color: "red" }}>{modalError.istaff_id}</p>
            ) : null}
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Company Name:
            </Form.Label>
            <Form.Control
              placeholder="Company Name"
              onChange={handleOnChange}
              name={"company_name"}
            />
            {modalError.company_name && modalError.foundErrors ? (
              <Form.Label style={{ color: "red" }}>
                {modalError.company_name}
              </Form.Label>
            ) : null}
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Company Address:
            </Form.Label>

            <Form.Control
              placeholder="Company Address"
              onChange={handleOnChange}
              name={"company_address"}
            />

            {modalError.company_address && modalError.foundErrors ? (
              <p style={{ color: "red" }}>{modalError.company_address}</p>
            ) : null}
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Company Contact Number:
            </Form.Label>

            <Form.Control
              placeholder="Company Contact"
              onChange={handleOnChange}
              name={"company_contact"}
            />

            {modalError.company_contact && modalError.foundErrors ? (
              <p style={{ color: "red" }}>{modalError.company_contact}</p>
            ) : null}
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Company Email Address:
            </Form.Label>

            <Form.Control
              placeholder="Award Name"
              onChange={handleOnChange}
              name={"email"}
            />

            {modalError.email && modalError.foundErrors ? (
              <p style={{ color: "red" }}>{modalError.email}</p>
            ) : null}
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Password:
            </Form.Label>

            <Form.Control
              type="password"
              placeholder="Password"
              onChange={handleOnChange}
              name={"password"}
            />

            {modalError.password1 && modalError.foundErrors ? (
              <p style={{ color: "red" }}>{modalError.password1}</p>
            ) : null}
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Confirm Password:
            </Form.Label>

            <Form.Control
              type="password"
              placeholder="Password"
              onChange={handleOnChange}
              name={"confirmpassword"}
            />
            {modalError.password2 && modalError.foundErrors ? (
              <p style={{ color: "red" }}>{modalError.password2}</p>
            ) : null}
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Award Name:
            </Form.Label>

            <Form.Control
              placeholder="Award Name"
              onChange={handleOnChange}
              name={"award_name"}
            />

            {modalError.award_name && modalError.foundErrors ? (
              <p style={{ color: "red" }}>{modalError.award_name}</p>
            ) : null}
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50" className="align-self-center">
              Registration Number:
            </Form.Label>

            <Form.Control
              placeholder="Registration Number"
              onChange={handleOnChange}
              name={"registration_number"}
            />
            {modalError.registration_number && modalError.foundErrors ? (
              <p style={{ color: "red" }}>{modalError.registration_number}</p>
            ) : null}
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Award Date:
            </Form.Label>

            <Form.Text column sm="50">
              <CustomDatePicker
                value={formData.award_date}
                onChange={handleAwardDateChange}
              />
            </Form.Text>

            {modalError.award_date && modalError.foundErrors ? (
              <p style={{ color: "red" }}>
                Make sure you have entered an Award Date.
              </p>
            ) : null}
          </Form.Group>

          <Form.Group>
            <Form.Label column sm="50">
              Client Logo URI:
            </Form.Label>

            <Form.Control
              placeholder="Client logo URI"
              onChange={handleOnChange}
              name={"client_logo_uri"}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        {!state.loading ? (
          <>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                handleSubmit(userToken, clients, dispatch);
              }}
            >
              Create New Client
            </Button>
          </>
        ) : (
          <SmallLoadingSpinner />
        )}
      </Modal.Footer>
    </Modal>
  );
};

function mapStateToProps(state) {
  return {
    userToken: state.userTokenReducer.userToken,
    clients: state.userPlacementsReducer.clients,
  };
}

export default connect(mapStateToProps)(CreateClientModal);
